/**
 * TOKEN STORAGE HELPERS
 *
 * WHY: We abstract localStorage behind helper functions so that:
 * 1. If we ever switch to sessionStorage or cookies, we change ONE file.
 * 2. JSON parsing errors are caught gracefully instead of crashing the app.
 * 3. Storage keys are centralized — no magic strings scattered in components.
 */
const STORAGE_KEYS = {
    ACCESS_TOKEN: 'auth_access_token',
    REFRESH_TOKEN: 'auth_refresh_token',
    USER: 'auth_user',
};
// -- Access Token --
export function getAccessToken() {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
}
export function setAccessToken(token) {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
}
export function removeAccessToken() {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
}
// -- Refresh Token --
export function getRefreshToken() {
    return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
}
export function setRefreshToken(token) {
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
}
export function removeRefreshToken() {
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
}
// -- User Object --
export function getStoredUser() {
    try {
        const raw = localStorage.getItem(STORAGE_KEYS.USER);
        // If nothing is stored, return null instead of crashing on JSON.parse(null)
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        // If the stored data is corrupted JSON, clear it and return null
        localStorage.removeItem(STORAGE_KEYS.USER);
        return null;
    }
}
export function setStoredUser(user) {
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
}
export function removeStoredUser() {
    localStorage.removeItem(STORAGE_KEYS.USER);
}
// -- Clear All Auth Data (used during logout) --
export function clearAllAuthData() {
    removeAccessToken();
    removeRefreshToken();
    removeStoredUser();
}
//# sourceMappingURL=storage.js.map